<template>
  <v-sheet>
    <v-navigation-drawer
      v-model="drawer"
      :mini-variant="mini"
      :color="appDrawerColor"
      :clipped="$vuetify.breakpoint.lgAndUp"
      app
    >
      <v-card
        flat
        tile
        v-if="user"
        class="card-center pt-5"
        color="transparent"
      >
        <v-card-text class="flex-items column">
          <v-avatar
            :size="`${!mini ? '6rem' : '3rem'}`"
            class="mb-2"
            :class="{ 'elevation-3': dark, 'elevation-6': !dark }"
          >
            <v-img :src="user.avatar"></v-img>
          </v-avatar>
          <div class="text-left pl-2" v-if="!mini">
            <h2 class="text-capitalize">{{ user.name }}</h2>
            <h5>{{ user.email }}</h5>
          </div>
        </v-card-text>
      </v-card>

      <v-list dense>
        <v-list-item link to="/dashboard">
          <v-list-item-action>
            <v-icon>$vuetify.icons.customers</v-icon>
          </v-list-item-action>

          <v-list-item-content> Customers </v-list-item-content>
        </v-list-item>

        <v-list-item v-if="user && user.isadmin" link to="/leads">
          <v-list-item-action>
            <v-icon>$vuetify.icons.leads</v-icon>
          </v-list-item-action>

          <v-list-item-content> Leads </v-list-item-content>
        </v-list-item>

        <v-list-item link to="/notifications">
          <v-list-item-action>
            <v-icon>mdi-bell-ring-outline</v-icon>
          </v-list-item-action>

          <v-list-item-content> Notifications </v-list-item-content>
        </v-list-item>

        <v-divider class="my-2" />

        <v-list-item link to="/checkins">
          <v-list-item-action>
            <v-icon>$vuetify.icons.checkins_vehicle</v-icon>
          </v-list-item-action>

          <v-list-item-content> Mileage Checkins </v-list-item-content>
        </v-list-item>

        <v-list-item link to="/condition-checkins">
          <v-list-item-action>
            <v-icon>$vuetify.icons.checkins_vehicle</v-icon>
          </v-list-item-action>
          <v-list-item-content> Condition Checkins </v-list-item-content>
        </v-list-item>

        <v-list-item link to="/policy-checkins">
          <v-list-item-action>
            <v-icon>$vuetify.icons.checkins_policy</v-icon>
          </v-list-item-action>

          <v-list-item-content> Policy Checkins </v-list-item-content>
        </v-list-item>

        <v-list-item link to="/proof-of-address-checkins">
          <v-list-item-action>
            <v-icon>$vuetify.icons.checkins_policy</v-icon>
          </v-list-item-action>

          <v-list-item-content>Proof of Address Checkins </v-list-item-content>
        </v-list-item>

        <v-list-item link to="/surveys">
          <v-list-item-action>
            <v-icon>$vuetify.icons.survey</v-icon>
          </v-list-item-action>

          <v-list-item-content> Surveys </v-list-item-content>
        </v-list-item>

        <v-list-item link to="/document-checkins">
          <v-list-item-action>
            <v-icon>mdi-file-document-check</v-icon>
          </v-list-item-action>

          <v-list-item-content> Document Checkins </v-list-item-content>
        </v-list-item>

        <v-list-group prepend-icon="mdi-folder-open">
          <template v-slot:activator>
            <v-list-item-content>Flows</v-list-item-content>
          </template>

          <v-list-item link to="/extended-warranty-flows">
            <v-list-item-action>
              <v-icon>mdi-shield-star</v-icon>
            </v-list-item-action>
            <v-list-item-content>Extended Warranty</v-list-item-content>
          </v-list-item>

          <v-list-item link to="/refinancing-flows">
            <v-list-item-action>
              <v-icon>mdi-bank</v-icon>
            </v-list-item-action>
            <v-list-item-content>Refinancing</v-list-item-content>
          </v-list-item>
        </v-list-group>

        <v-list-item link to="/service-checkins">
          <v-list-item-action>
            <v-icon>$vuetify.icons.checkins_vehicle</v-icon>
          </v-list-item-action>
          <v-list-item-content> Service Checkins </v-list-item-content>
        </v-list-item>

        <v-list-item link to="/property-checkins">
          <v-list-item-action>
            <v-icon>$vuetify.icons.checkins_property</v-icon>
          </v-list-item-action>

          <v-list-item-content> Property Checkins </v-list-item-content>
        </v-list-item>

        <v-list-item link to="/connected-policy-checkins">
          <v-list-item-action>
            <v-icon>$vuetify.icons.checkins_policy</v-icon>
          </v-list-item-action>

          <v-list-item-content>Canopy Policy Checkins </v-list-item-content>
        </v-list-item>
        <v-divider v-if="user && user.isadmin" class="my-2" />

        <v-list-item v-if="user && user.isadmin" link to="/rewards">
          <v-list-item-action>
            <v-icon>$vuetify.icons.rewards</v-icon>
          </v-list-item-action>

          <v-list-item-content> Rewards </v-list-item-content>
        </v-list-item>

        <v-list-item v-if="user && user.isadmin" link to="/payouts">
          <v-list-item-action>
            <v-icon>$vuetify.icons.payouts</v-icon>
          </v-list-item-action>

          <v-list-item-content> Payouts </v-list-item-content>
        </v-list-item>

        <v-divider v-if="user && user.isadmin" class="my-2" />

        <v-list-item v-if="user && user.isadmin" link to="/insurance">
          <v-list-item-action>
            <v-icon>$vuetify.icons.insurance</v-icon>
          </v-list-item-action>

          <v-list-item-content> Ins. Providers </v-list-item-content>
        </v-list-item>

        <v-list-item v-if="user && user.isadmin" link to="/data-buyers">
          <v-list-item-action>
            <v-icon>$vuetify.icons.databuyer</v-icon>
          </v-list-item-action>

          <v-list-item-content> Data Buyers </v-list-item-content>
        </v-list-item>

        <v-list-item v-if="user && user.isadmin" link to="/campaigns">
          <v-list-item-action>
            <v-icon>$vuetify.icons.campaigns</v-icon>
          </v-list-item-action>

          <v-list-item-content> Campaigns </v-list-item-content>
        </v-list-item>

        <v-list-item v-if="user && user.isadmin" link to="/reports">
          <v-list-item-action>
            <v-icon>$vuetify.icons.report</v-icon>
          </v-list-item-action>

          <v-list-item-content> Reports </v-list-item-content>
        </v-list-item>

        <v-list-item v-if="user && user.isadmin" link to="/integrations-tester">
          <v-list-item-action>
            <v-icon>$vuetify.icons.correct</v-icon>
          </v-list-item-action>

          <v-list-item-content> Integrations Tester </v-list-item-content>
        </v-list-item>

        <v-list-item v-if="user && user.isadmin" link to="/check-in-builder">
          <v-list-item-action>
            <v-icon>$vuetify.icons.correct</v-icon>
          </v-list-item-action>

          <v-list-item-content> Check-in Builder </v-list-item-content>
        </v-list-item>

        <v-divider class="my-2" />

        <v-list-item>
          <v-list-item-action>
            <v-icon
              v-html="
                dark ? '$vuetify.icons.dark_mode' : '$vuetify.icons.bright_mode'
              "
            ></v-icon>
          </v-list-item-action>

          <v-list-item-content>
            <v-switch
              :value="dark"
              :input-value="dark"
              :label="`Eco Mode`"
              @change="updateDark(!dark)"
              hide-details
              class="ma-0"
            ></v-switch>
          </v-list-item-content>
        </v-list-item>

        <v-list-item @change="updateMini(!mini)">
          <v-list-item-action>
            <v-icon>$vuetify.icons.mini_mode</v-icon>
          </v-list-item-action>

          <v-list-item-content>
            {{ mini ? "Expand" : "Minimize" }}
          </v-list-item-content>
        </v-list-item>

        <v-list-item @click="logout">
          <v-list-item-action>
            <v-icon>$vuetify.icons.logout</v-icon>
          </v-list-item-action>

          <v-list-item-content> Log-Out </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-divider class="my-2" />

      <v-spacer />
    </v-navigation-drawer>

    <v-app-bar
      app
      flat
      :clipped-left="$vuetify.breakpoint.lgAndUp"
      :color="appBarColor"
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>

      <v-toolbar-title class="pa-0" v-html="title"></v-toolbar-title>

      <v-spacer></v-spacer>
      <v-toolbar-title
        class="font-weight-bold pa-0"
        v-html="env"
      ></v-toolbar-title>
      <v-spacer></v-spacer>

      <v-badge
        bordered
        color="primary"
        overlap
        bottom
        left
        :content="sysNotifications.length"
        :value="sysNotifications.length"
      >
        <v-btn
          icon
          small
          to="/notifications"
          :disabled="sysNotifications.length == 0"
        >
          <v-icon v-if="sysNotifications.length"
            >$vuetify.icons.notifications_on</v-icon
          >
          <v-icon v-else>$vuetify.icons.notifications_off</v-icon>
        </v-btn>
      </v-badge>

      <v-btn icon small to="/dashboard">
        <v-avatar :size="32">
          <BrandLogo />
        </v-avatar>
      </v-btn>
      <span></span>
    </v-app-bar>

    <v-main fill-height class="pos-r">
      <transition name="fade" mode="out-in">
        <slot />
      </transition>
    </v-main>
  </v-sheet>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import NetworkIndicator from "@/components/NetworkIndicator";
import PwaInstallerBtn from "@/components/PwaInstallerBtn";

export default {
  name: "DefaultLayout",

  components: {
    NetworkIndicator,
    PwaInstallerBtn,
  },

  computed: {
    ...mapGetters("customer", ["customer", "partner"]),
    ...mapGetters("auth", ["authenticated", "user"]),
    ...mapGetters("appshell", [
      "dark",
      "mini",
      "connected",
      "platform",
      "isMobileDevice",
      "loading",
      "sysNotifications",
    ]),

    vehiclesCount() {
      return (
        this.customer && this.customer.vehicles && this.customer.vehicles.length
      );
    },

    title() {
      return this.$route.meta.title || document.title;
    },

    env() {
      // GCP builds set this at build time (gcloud/admin-ui/_config.sh). Azure
      // builds leave it unset and fall through to the hostname switch, whose
      // `default` is "Production" — which is why a new environment has to
      // supply the label rather than rely on being recognised here.
      if (process.env.VUE_APP_ENV_LABEL) {
        return process.env.VUE_APP_ENV_LABEL;
      }

      switch (document.location.host) {
        case "localhost:8080":
          return "Development";

        case "staging-mng.joinparked.com":
          return "Staging";

        case "staging-mng.ownli.app":
          return "Staging";

        case "dev-mng.ownli.app":
          return "Development";

        default:
          return "Production";
      }
    },

    year() {
      return new Date().getFullYear();
    },
    appBarColor() {
      return !this.dark ? "white" : "black";
    },
    appDrawerColor() {
      return !this.dark ? "white" : "black";
    },
    baseBgColor() {
      return !this.dark ? "grey lighten-4" : "black";
    },
  },

  methods: {
    ...mapActions("auth", ["login", "logout"]),
    ...mapActions("appshell", ["updateDark", "updateMini"]),
  },

  data: () => ({
    dialog: false,
    drawer: null,
  }),
};
</script>

<style lang="css" scoped>
#layout-default >>> .v-navigation-drawer__content {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: end;
}

/* Sidebar typography — scaled to ~80%, matching the compact-ui scale used on the
   condition check-in pages. Row height is reduced alongside the text: on a nav list it
   is what actually decides how many items clear the fold. The drawer's own width is
   deliberately untouched, since Vuetify derives the main content offset from it. */
.v-navigation-drawer >>> .v-list-item__content {
  font-size: 10px;
  letter-spacing: 0.2px;
}

.v-navigation-drawer >>> .v-list-item__title {
  font-size: 10px;
  line-height: 1.2;
}

.v-navigation-drawer >>> .v-list-item {
  min-height: 30px;
}

.v-navigation-drawer >>> .v-list-item__action {
  margin-right: 12px;
}

.v-navigation-drawer >>> .v-list-item__action,
.v-navigation-drawer >>> .v-list-item__icon {
  margin-top: 4px;
  margin-bottom: 4px;
}

.v-navigation-drawer >>> .v-list-item__icon .v-icon,
.v-navigation-drawer >>> .v-list-item__action .v-icon {
  font-size: 16px;
}

.v-navigation-drawer >>> h2 {
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.2px;
  margin: 0;
}

.v-navigation-drawer >>> h5 {
  font-size: 10px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.6);
  margin-top: 2px;
}

.v-navigation-drawer >>> .v-label {
  font-size: 10px;
}
</style>
